import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, Button, CircularProgress } from '@mui/material';
import { CheckCircle } from 'lucide-react';

export function BillingSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Verify the session
    const verifySession = async () => {
      if (!sessionId) {
        navigate('/settings');
        return;
      }

      // Give webhooks time to process
      await new Promise((resolve) => setTimeout(resolve, 2000));
      setIsVerifying(false);
    };

    verifySession();
  }, [sessionId, navigate]);

  if (isVerifying) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 8 }}>
      <Card>
        <CardContent sx={{ textAlign: 'center', py: 6 }}>
          <CheckCircle size={64} color="#4caf50" style={{ marginBottom: 16 }} />

          <Typography variant="h4" gutterBottom>
            Subscription Activated!
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Your Portfolio Operations Analyst is now active and ready to work.
          </Typography>

          <Button variant="contained" size="large" onClick={() => navigate('/settings')}>
            Go to Settings
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
